import { Flex } from 'antd';
import { FcGoogle } from 'react-icons/fc';
import styles from './GoogleSignIn.module.scss';
import toast from 'react-hot-toast';
import { Button } from '../../common';
import { useEffect, useState } from 'react';
import APIController from '../../api/core-api-controller';
import { fetchUserData } from '../../api/auth-user-api';
import { setPatientUser } from '../../reducers/patient-user-slice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getErrorString } from '../../utils';
import { getSessionStorage, removeSingleCookie, setCookie, setSessionStorage } from '../../utils/cookies-util';

const GoogleSignIn = ({ handleLogin, fromPage, text, isSignupPage }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  const error = params.get('error');
  const message = params.get('message');
  const signup = params.get('signup');
  const affiliate_token = params.get('ref_token') ?? params.get('affiliate_token') ?? getSessionStorage('affiliate_token');

  useEffect(() => {
    const newUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);

    if (token) {
      fetchData(token);
    }
    if (error) toast.error(error || 'Unable to login');
    if (message) toast.success(message || '');
  }, [token, error]);

  const fetchData = async (token) => {
    setCookie('access-token-user', `Bearer ${token}`);
    setLoading(true);
    try {
      const payload = {
        affiliate_token: affiliate_token,
      };
      const res = await fetchUserData(affiliate_token && signup ? payload : {});
      if (res && res?.id) {
        dispatch(setPatientUser(res ?? {}));
        setCookie('access-token-user', `Bearer ${token}`);
        removeSingleCookie('resend-time');
        removeSingleCookie('resend-link-time');
        setSessionStorage('affiliate_token', '');

        // ✅ Inject Convert conversion tracking for Google sign-up
        if (isSignupPage) {
          try {
            window._conv_q = window._conv_q || [];
            window._conv_q.push(['triggerConversion', '100498374']);
          } catch (err) {
            console.error('Convert conversion tracking failed', err);
          }
        }

        handleLogin();
        navigate(fromPage, { replace: true });
        return;
      } else {
        toast.error(res?.message ?? 'Login Failed');
        return;
      }
    } catch (error) {
      toast.error(getErrorString(error));
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    return window.open(
      `${APIController.baseUrl}/client_users/auth/google_oauth2${affiliate_token ? `?ref_token=${affiliate_token}` : ''}`,
      '_self',
    );
  };

  return (
    <Button onClick={() => handleGoogleSignIn()} loading={loading} type={'text'} className={styles.buttonStyle}>
      <Flex justify="center" align="center" gap={16}>
        <FcGoogle size={24} />
        <div className={styles.textStyle}>{text ?? 'Continue with Google'}</div>
      </Flex>
    </Button>
  );
};

export default GoogleSignIn;
